import * as calls from "./apiCalls";
import * as action from "./actions";
import * as selector from "./selectors";
import { physicianProfileReducer as reducer } from "./reducers";

export const notificationSMSCalls = calls;
export const notificationSMSActions = action;
export const notificationSMSSelectors = selector;
export const notificationSMSReducer = reducer;
